import { useEffect, useState } from 'react';
import axios from 'axios';
import { AlertCircle, X } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function WelfareAlertsBanner() {
  const [alerts, setAlerts] = useState([]);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API}/welfare/alerts`);
        if (!cancelled && res.data?.alerts_enabled && res.data.alerts?.length) {
          setAlerts(res.data.alerts);
        }
      } catch (e) {
        // silent — alerts are non-critical
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (dismissed || alerts.length === 0) return null;

  return (
    <div
      className="rounded-xl border border-amber-200 bg-amber-50 p-4 flex items-start gap-3"
      data-testid="welfare-alerts-banner"
    >
      <AlertCircle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" strokeWidth={1.75} />
      <div className="flex-1 min-w-0">
        <p className="font-medium text-amber-900 text-sm mb-1">A gentle heads-up</p>
        <ul className="space-y-1 text-sm text-amber-800">
          {alerts.map(a => (
            <li key={a.metric} data-testid={`welfare-alert-${a.metric}`}>• {a.message}</li>
          ))}
        </ul>
        <p className="text-xs text-amber-700 mt-2">Adjust thresholds or silence alerts in the Settings tab.</p>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="text-amber-600 hover:text-amber-800 p-1 -m-1 rounded transition-colors"
        aria-label="Dismiss"
        data-testid="welfare-alerts-dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
